import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import { Button, Modal } from "components";
import { INVESTOR_VERIFICATION_URL } from "constants/index";

interface VerificationModalProps {
  open: boolean;
  onClose: () => void;
}

const VerificationModal: FC<VerificationModalProps> = props => (
  <Modal
    title="Become a Verified Investor"
    open={props.open}
    onClose={props.onClose}
  >
    <Typography>
      To make offers and purchase assets on Royalty Exchange, you must complete
      an investor verification. This free service only takes a few minutes to
      complete.
      <br /> <br />
      Start by answering a short questionnaire about your investing background
      by clicking the button below.
      <br />
      <br />
    </Typography>
    <Box textAlign="center">
      <Button
        customColor="green"
        fullWidth
        variant="contained"
        size="large"
        component={Link}
        to={{
          pathname: INVESTOR_VERIFICATION_URL,
        }}
        target="blank"
      >
        Get Verified
      </Button>
    </Box>
  </Modal>
);

export default VerificationModal;
